import { render, staticRenderFns } from "./Wallpapers.vue?vue&type=template&id=488af575"
import script from "./Wallpapers.ts?vue&type=script&lang=ts&external"
export * from "./Wallpapers.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports